import script from "./ThanksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThanksPage.vue?vue&type=script&setup=true&lang=js"

import "./ThanksPage.vue?vue&type=style&index=0&id=6bec080b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bec080b"]])

export default __exports__